import React, { useState } from 'react';

// Thumbnails range from near-square to wide banners, so the image is fitted inside a plate of
// fixed size rather than cropped to a common ratio.
//
// The listing shows them under 200px wide while the sources are full slide exports, so the
// build writes a small WebP next to each one. If that derivative is missing or cannot be
// decoded, the image retries the original source instead.
export default function EntryThumbnail({ entry, basePath, text }) {
  const [failed, setFailed] = useState(false);
  const [webpFailed, setWebpFailed] = useState(false);

  if (!entry.thumbnail || failed) {
    return <div className="publication-thumbnail publication-thumbnail-missing">{text('Sem miniatura', 'No thumbnail')}</div>;
  }

  const original = `/${basePath}/thumbnail/${entry.thumbnail}`;
  const webp = original.replace(/\.(png|jpe?g)$/i, '.webp');

  return <picture>
    {!webpFailed && <source srcSet={webp} type="image/webp" />}
    <img
      key={webpFailed ? 'original' : 'optimized'}
      className="publication-thumbnail"
      src={original}
      alt=""
      loading="lazy"
      decoding="async"
      onError={() => {
        // The optimized WebP is generated during production builds, but may be absent in
        // development or when cwebp is unavailable. Drop the source and retry the original.
        if (!webpFailed) setWebpFailed(true);
        else setFailed(true);
      }}
    />
  </picture>;
}
